module.exports = "pegasus_template/assets/tech/npo_1/101.png";